var $ = require('jquery');
var Backbone = require('backbone');
var _ = require('underscore');

var AppView = require('./AppView');

var CO = {};

CO.pubSub = _.extend({}, Backbone.Events);

$(document).ready(function(){
	CO.view = new AppView();
	CO.view.render();
});

global.CO = CO;